/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function GetCountContactsEmailTransactionsResponseDataFromJSON(json) {
    return GetCountContactsEmailTransactionsResponseDataFromJSONTyped(json, false);
}
export function GetCountContactsEmailTransactionsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        count: !exists(json, 'count') ? undefined : json['count']
    };
}
export function GetCountContactsEmailTransactionsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        count: value.count
    };
}
